const mistakes = [
  { title: "Study Abroad Last Minute", desc: "UA students often wait until 3 weeks before departure to start the passport process. Start as soon as you're accepted." },
  { title: "Wrong Photo", desc: "Photos from campus CVS are often rejected. We verify your photo specs before you submit." },
  { title: "Expired Identification", desc: "Some students try to use expired student IDs at acceptance facilities. Only valid government photo ID is accepted." },
  { title: "Corporate Booking Before Passport", desc: "NWA corporate travelers sometimes book non-refundable international flights before checking passport expiration dates." },
  { title: "Wrong Application Form", desc: "DS-11 vs DS-82 confusion is common. We tell you exactly which form based on your passport history." },
];

export default function FayettevilleARMistakesSection() {
  return (
    <section id="mistakes" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">5 Mistakes Fayetteville, AR Applicants Make</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4"><i className="ri-close-circle-line text-red-500 text-xl"></i></div>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}